import ObjClass from './ObjClass';
import { PersistentData } from './Service';
import User from './User';
import AppointmentType from './AppointmentType';
import Clinic from './Clinic';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import momentDurationFormatSetup from "moment-duration-format";


const moment = extendMoment(Moment);

momentDurationFormatSetup(moment);

export default class Appointment extends ObjClass{

	constructor(o){
		super(o);
		this.client = new User(this.client);
		this.clinic = new Clinic(this.clinicId);
		this.doctor = this.clinic.getDoctor(this.userId);
	}

	/**
     *
     * @returns {AppointmentType}
     */
	get appointmentType(){
		if(!this._appType){
			this._appType = AppointmentType.GetById(this.appointmentTypeId, this.clinicId);// new AppointmentType(this.clinicId, this.appointmentTypeId);
		}
		return this._appType;
	}

	get $dateTime() {
		return Appointment.FormatAppDateTime(this);
	}

	get $dateDuration() {
		return Appointment.FormatAppDateTimeDuration(this);
	}

	get hasPrescription() {
		return this.clientHasRx;// this.client.fullName.charAt(this.client.fullName.length - 1) === '*';
	}

	static FormatAppId(app){
		return this.FormatAppDateTime(app) + ' Dr:' + app.userId;
	}

	//Can be used to determine if 2 appointments are the same date and time
	static FormatAppDateTime(app){
		return moment(app.start).format('YYYY/M/D') + ' ' + this.FormatTimeRange(app);
	}

	static FormatTime(t){
		let time = moment(t);
		let format = 'h:mm a';
		if(time.minute() == 0){
			format = 'h a';
		}

		return time.format(format);
	}

	static FormatTimeRange(app){
		return this.FormatTime(app.start) + ' - ' + this.FormatTime(app.end);
	}

	static FormatAppDateTimeDuration(app) {
		const s = moment(app.start);
		const e = moment(app.end);
		const diff = e.diff(s, 'minutes');
		const d = moment.duration(diff, 'minute');
		return moment(app.start).format('MMM Do, YYYY') + ' @' + this.FormatTime(app.start) + ' (' +  d.format('hh:mm', {
			trim: true
		}) + ')';
	}

	static FindConflicts(apps){
		for(let i=0; i < apps.length; i++){
			let app = apps[i];
			app.conflicts = [];
			for(let j=0; j < apps.length; j++){
				let comp = apps[j];
				if((app.appointmentId !== comp.appointmentId) && ( app.userId === comp.userId )){
					let r1 = moment.range(moment(app.start), moment(app.end));
					let r2 = moment.range(moment(comp.start), moment(comp.end));
					if(r1.overlaps(r2)){
						app.conflicts.push(comp);
					}
				}
			}
		}
		return apps;
	}
}

export function ParseConflicts(app, cache){
	let _cache = cache || {};
	let conflicts = app.conflicts;
	for(let i=0 ; i < conflicts.length; i++){
		let ac = conflicts[i];
		if(!_cache[ac.appointmentId]){
			_cache[ac.appointmentId] = true;
			ParseConflicts(ac, _cache);
		}
	}

	let c = 0;

	for(let p in _cache){
		_cache[p] = c++;
	}
	return _cache;
}







/*class AppointmentType extends ObjClass{
    constructor(clinicId, id){
        super({});
        let pd = new PersistentData('ClinicData/Clinic/' + clinicId + '/AppointmentTypes');
        this._populate(pd.getData(id));
    }

    static getAll(clinicId){
        let pd = new PersistentData('ClinicData/Clinic/' + clinicId + '/AppointmentTypes')
        return pd.getAll();
    }
}*/



// WEBPACK FOOTER //
// ./src/api/Appointment.js